var uiPagination = {
	caption: "Paginazione",
	page: "Pagina {page}",
	first: "Prima pagina",
	previous: "Pagina precedente",
	next: "Prossima pagina",
	last: "Ultima pagina"
};
var it = {
	uiPagination: uiPagination
};

export { it as default, uiPagination };
